import {Action} from 'redux'
import {NabilAuctionCategoryModel} from '../Model/Model'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialNabilAuctionCategoryState: INabilAuctionCategoryState = {
  data: {
    nabilAuctionCategory: [],
    meta: [],
  },
  sortNabilAuctionCategoryData: [],
  nabilAuctionCategoryList: {nabilAuctionCategory: []},
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface INabilAuctionCategoryState {
  data?: {
    nabilAuctionCategory?: NabilAuctionCategoryModel[]
    meta?: {[key: string]: string | number}[]
  }
  sortNabilAuctionCategoryData?: INabilAuctionCategoryState[]
  nabilAuctionCategoryList?: {nabilAuctionCategory: NabilAuctionCategoryModel[]}
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: INabilAuctionCategoryState = initialNabilAuctionCategoryState,
  action: ActionWithPayload<INabilAuctionCategoryState>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_NABIL_AUCTION_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_NABIL_AUCTION_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        nabilAuctionCategoryList: action.payload,
        loading: false,
      }
    }

    case actionTypes.GET_ALL_NABIL_AUCTION_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //GET NabilAuctionCategory DATA
    case actionTypes.GET_NABIL_AUCTION_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_NABIL_AUCTION_CATEGORY_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_NABIL_AUCTION_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add NabilAuctionCategory
    case actionTypes.ADD_NABIL_AUCTION_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_NABIL_AUCTION_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_NABIL_AUCTION_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_NABIL_AUCTION_CATEGORY: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update NabilAuctionCategory
    case actionTypes.UPDATE_NABIL_AUCTION_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_NABIL_AUCTION_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_NABIL_AUCTION_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_NABIL_AUCTION_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_NABIL_AUCTION_CATEGORY_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_NABIL_AUCTION_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_NABIL_AUCTION_CATEGORY_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_NABIL_AUCTION_CATEGORY_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_NABIL_AUCTION_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_NABIL_AUCTION_CATEGORY_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_NABIL_AUCTION_CATEGORY_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_NABIL_AUCTION_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_NABIL_AUCTION_CATEGORY_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_NABIL_AUCTION_CATEGORY_SUCCESS: {
      const changedData: any = action.payload?.data?.nabilAuctionCategory
      let newData = state?.data?.nabilAuctionCategory?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, nabilAuctionCategory: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_NABIL_AUCTION_CATEGORY_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_NABIL_AUCTION_CATEGORY_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_NABIL_AUCTION_CATEGORY_SUCCESS: {
      const changedData: any = action.payload?.data?.nabilAuctionCategory
      let newData = state?.data?.nabilAuctionCategory?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, nabilAuctionCategory: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_NABIL_AUCTION_CATEGORY_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    // sort
    case actionTypes.SORT_NABIL_AUCTION_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_NABIL_AUCTION_CATEGORY_SUCCESS: {
      return {
        ...state,
        sortNabilAuctionCategoryData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_NABIL_AUCTION_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_NABIL_AUCTION_CATEGORY_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortNabilAuctionCategoryData: [],
      }
    }

    default:
      return state
  }
}
